/**
 * Navigation parity with https://www.ys142857.com (legacy uni-app prod).
 * Routes / menu keys not on prod are hidden and redirect to /wallet.
 */

/** Authenticated routes with no prod equivalent. */
export const PROD_HIDDEN_ROUTES = new Set([
  '/news',
  '/rank',
  '/contract',
  '/invite',
  '/ep-pricing',
  '/withdraw',
  '/recharge',
  '/email-verify',
  '/support',
  '/otc',
  '/pcc',
  '/auction',
  '/staking',
  '/dex',
  '/ecosystem',
  '/inbox',
]);

/** Me → 交易管理 items absent on prod 個人中心. */
export const PROD_HIDDEN_ME_KEYS = new Set<string>([
  'me_market.register_member',
  'me_market.uo_trading',
  'me_market.ep_trading',
  'wallet.uo_trading',
  'wallet.ep_trading',
]);

/** Wallet home feature grid — hide trading shortcuts (use bottom tabs). */
export const PROD_HIDDEN_WALLET_FEATURES = new Set<string>([
  'wallet.uo_trading',
  'wallet.ep_trading',
  'wallet.sell_uo',
]);

/** Fuel moved to Me → 资产变换 (购买燃料); no longer on wallet home. */
export const PROD_WALLET_FUEL_LABEL_KEY = 'wallet.fuel';
export const PROD_WALLET_SHOW_FUEL_TILE = false;

/** History page — ORBC not used on prod. */
export const PROD_HIDDEN_HISTORY_ASSETS = new Set<string>(['uoc']);
export const PROD_HIDDEN_HISTORY_ACTIONS = new Set<string>([
  'uoc_mint',
  'uoc_burn',
  'uoc_withdraw',
]);

export function normalizeRoutePath(path: string): string {
  const base = path.split('?')[0] ?? path;
  if (!base.startsWith('/')) return `/${base}`;
  return base;
}

export function isProdRouteVisible(path: string): boolean {
  return !PROD_HIDDEN_ROUTES.has(normalizeRoutePath(path));
}

export function filterProdRoutes<T extends { to?: string; route?: string }>(items: T[]): T[] {
  return items.filter((item) => {
    const path = item.to ?? item.route;
    return !path || isProdRouteVisible(path);
  });
}

export function filterProdMeKeys<T extends { key: string; to?: string }>(items: T[]): T[] {
  return items.filter(
    (item) => !PROD_HIDDEN_ME_KEYS.has(item.key) && (!item.to || isProdRouteVisible(item.to)),
  );
}

/** Prod wallet home: assets + chart + order book — feature grid includes 购买燃料. */
export const PROD_WALLET_SHOW_QUICK_ACTIONS = false;
export const PROD_WALLET_SHOW_FEATURE_GRID = true;
export const PROD_WALLET_SHOW_NEWS = true; // wallet ticker + news list (公告)
export const PROD_WALLET_SHOW_CONVERT = false;
export const PROD_ME_SHOW_INVITE_BANNER = false;
export const PROD_LOGIN_SHOW_WALLET = true;
